import React from "react";
import QurealCanvasWrapper from "./QurealCanvasWrapper";
import QurealBlogs from "../../blog_bot/QurealBlogs";
import { Button, message, Popconfirm } from "antd";
import { useMeasure } from "react-use";
import CanvasFeedbackBar from "./CanvasFeedbackBar";
import { DeleteOutlined } from "@ant-design/icons";
import { useDeleteItemMutation } from "../../_actions/app/items";
import { queryClient } from "../../_helpers/query";
import SocialPostingBox from "../../social_media/SocialPostingBox";

function QurealBlogPreview({
    data,
    closeBtn,
    close_left,
    open_cust,
    setOpenCust,
    history_id,
    entry_id,
    platforms,
    close = () => { },
    me,
}) {
    // const [ref, { x, y, width, height, top, right, bottom, left }] = useMeasure();
    console.log("Blog Data:", data);

    const org_id = me?.selected_org?.id;
    const deleteMutation = useDeleteItemMutation(() => {
        message.success("Entry deleted successfully!");
        queryClient.invalidateQueries(["items", "qdb_calendar_entries"]);
        if (close) close();
    });

    const handleCopy = () => {
        navigator.clipboard
            .writeText(data.content)
            .then(() => {
                console.log("Data copied to clipboard");
                message.success("Data copied to clipboard");
            })
            .catch((err) => {
                console.error("Failed to copy data: ", err);
                message.error("Failed to copy");
            });
    };
    return (
        <QurealCanvasWrapper
            title="Blog Preview"
            actions_left={close_left ? [closeBtn] : []}
            actions={[
                <Button>Rewrite</Button>,
                // <Button
                //     onClick={() => {
                //         setOpenCust(!open_cust);
                //     }}
                // >
                //     Edit
                // </Button>,
                <Button onClick={handleCopy}>Copy</Button>,
                <Button type="primary">Publish</Button>,
                !close_left && closeBtn,
            ]}
            header_height={50}
            controlPanel={
                <div style={{ padding: "15px", height: "100%", overflowY: "auto", display: "flex", flexDirection: "column" }}>
                    <div style={{ flex: 1 }}>
                        <SocialPostingBox
                            platforms={platforms}
                            entry_id={entry_id}
                            org_id={org_id}
                        />
                    </div>
                    {entry_id ? <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        paddingTop: "20px"
                    }}

                    >
                        <Popconfirm
                            title="Delete entry"
                            description="Are you sure you want to delete this entry?"
                            onConfirm={() => {
                                deleteMutation.mutate({
                                    collection: "qdb_calendar_entries",
                                    id: entry_id,
                                });
                            }}
                            okText="Yes"
                            cancelText="No"
                            okButtonProps={{ danger: true }}
                        >
                            <Button danger icon={<DeleteOutlined />} loading={deleteMutation.isLoading}>Delete</Button>
                        </Popconfirm>
                    </div> : null}
                </div>
            }
            open_cp={open_cust}
            setOpenCp={setOpenCust}
        >
            <div
                style={{
                    // width: "100%",
                    height: "100%",
                    maxHeight: "90vh",
                    overflowY: "auto",
                }}
            >
                <QurealBlogs initialContent={data} key={data?.title?.length} />
            </div>
            <CanvasFeedbackBar history_id={history_id} entry_id={entry_id} />
        </QurealCanvasWrapper>
    );
}

export default QurealBlogPreview;
